/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-11-20 09:53:27
 * @LastEditors: hongye
 * @LastEditTime: 2025-11-20 10:27:30
 * @Description: file content
 */
import { Router } from 'vue-router'
import { useSettingStore, useTabStore, useAuthStore } from '@/store'
import isObject from 'lodash/isObject'
import { restructureMeta } from '@/utils'
import { getVersion, versionCheck } from '@/utils/checkVersion'
import { flatMenus, MenuItemIn } from '@/layout/menu/menus'
getVersion() // 触发页面监听
//获取url所在对象
const getItemByUrl = (url: string | number) => {
  return flatMenus.find((_) => _.menuUrl === url)
}

function setMenuStatus(this: any, findMenu: MenuItemIn) {
  if (!isObject(findMenu)) return
  this.setSelectedKeys([findMenu.id])
}
const whiteListArray = ['/storeManagement', '/findPwd', '/download/center']
const routerBefore = (router: Router) => {
  router.beforeEach(async (to, from, next) => {
    const [settingStore, tabStore, authStore] = [useSettingStore(), useTabStore(), useAuthStore()]
    const isMaster = authStore.userInfo.staffType?.id === 'WEBMASTER'
    const findMenu = getItemByUrl(to.path) as MenuItemIn
    const hasPermission = isObject(findMenu) || whiteListArray.includes(to.path)
    if (to.name !== 'Login') {
      if (to.meta.requiresAuth && !authStore.isLoggedIn) {
        next({ name: 'Login' })
      } else if (!isMaster && !hasPermission && to.meta.requiresAuth) {
        //需要认证，无权限的
        to.name !== 'NoAuth' ? next({ name: 'NoAuth' }) : next()
      } else {
        //处理菜单选中状态
        setMenuStatus.call(settingStore, findMenu)
        tabStore.setTabs({ name: to.name as string, path: to.fullPath, meta: restructureMeta(to) })
        next()
      }
    } else {
      next()
    }
  })
  router.afterEach((to, from) => {
    versionCheck()
  })
}

export default routerBefore
